/* eslint-disable no-console */

import Vue          from "vue";
import VueTruncate  from "vue-truncate-filter";
import BootstrapVue from "bootstrap-vue";
import { Settings } from "luxon";
import Datetime     from "vue-datetime";
import moment       from "moment";
import Toasted      from "vue-toasted";
import App          from "./App";

import "vue-datetime/dist/vue-datetime.css";
import "nprogress/nprogress.css";

import router from "./router";
import { store } from "@/store";

Settings.defaultLocale = "fr";

Vue.use(Toasted);
Vue.use(require("vue-moment"));
Vue.use(Datetime);
Vue.use(BootstrapVue);
Vue.use(VueTruncate);

Vue.config.productionTip = false;

Vue.filter("formatDate", (value) => {
	if (value) {
		return moment(String(value)).format("MM/DD/YYYY hh:mm");
	}
});

new Vue({
	el: "#app",
	router,
	store,
	components: {
		App
	},
	template: "<App/>",
});